import PropTypes from 'prop-types';
import React from 'react';
import { ReactSortable } from 'react-sortablejs';
import PlaylistItem from './PlaylistItem'
import Confirmation from 'lib/components/ConfirmationModal'
import $ from 'jquery';
import {
  Button,
  FieldGroup,
  FloatingLabelFormField,
  FormSection,
  PageWrapper,
  SelectAsyncControl,
  Section
} from 'reactifi';
import i18n from 'lib/utility/i18n';

export default class Playlist extends React.Component {

  static propTypes = {
    content: PropTypes.array.isRequired,
    contentServiceUrl: PropTypes.string,
    id: PropTypes.number.isRequired,
    jwt: PropTypes.string,
    playlist_items: PropTypes.array
  }

  constructor(props) {
    super(props);

    this.state = {
      alertClass: '',
      alertMessage: '',
      existingContentIds: [],
      hideAlert: true,
      id: this.props.id,
      isDeleting: false,
      itemToDelete: '',
      newPlaylistItem: null,
      playlistItems: this.props.playlist_items,
      renderSelect: null,
      runValidation: false,
      toDeleteContentId: null
    }
  }

  componentDidMount() {
    const { playlistItems } = this.state;
    const existingContentIds = playlistItems ? playlistItems.map(content => String(content.content_id)) : [];

    this.setState({ existingContentIds });
  }

  addPlaylistItem = () => {
    const { newPlaylistItem } = this.state;

    if (!newPlaylistItem) {
      return this.setState({ runValidation: true });
    }

    $.ajax({
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      dataType: 'JSON',
      method: 'POST',
      url: `${window.origin}/api/data/playlist_items`,
      data: JSON.stringify({ data: newPlaylistItem }),
      success: this.addPlaylistItemSuccess
    });
  };

  addPlaylistItemSuccess = () => {
    this.showAlert('success', i18n.t('Playlist item has been successfully saved.'));
    window.location.reload();
  }

  onContentChange = val => {
    const { id } = this.props;
    const { playlistItems } = this.state;

    const newPlaylistItem = val ? {
      type: 'playlist_items',
      attributes: {
        content_id: val.id,
        playlist_id: id,
        position: (playlistItems.length) + 1
      }
    } : null;
    this.setState({ newPlaylistItem, runValidation: false });
  }

  getContentConfigData = async (ids) => {
    const { contentServiceUrl, jwt } = this.props;
    const apiUrl = `${contentServiceUrl}/api/v1/contents.json?include=content_config&filter[ids]=${ids}`;
    const data = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        Authorization: `Bearer ${jwt}`,
        Cache: 'no-cache'
      },
      mode: 'cors',
      credentials: 'same-origin'
    });
    return await data.json();
  }

  augmentedOptionsDisplay = async (options) => {
    if(!options.length) return options;
    const contentIds = options.map(option => option.data.content_id);
    const configData = await this.getContentConfigData(contentIds);
    if(!configData) return options;
    return options.map(option => {
      const config_id = configData.data.find(cData => option.data.content_id === cData.id)?.attributes?.content_config_id;
      const dataToAppend = configData.hasOwnProperty('included') ? configData.included.filter(e => e.id === config_id) : null;
      const display = dataToAppend && dataToAppend.length ? `${option.display} - (${dataToAppend[0].attributes.name})` : option.display;

      option.data.name = display;

      return option;
    });
  }

  getContentSelect = () => {
    const { existingContentIds, runValidation } = this.state;
    return (
      <FormSection title={i18n.t('Select a content item to add to the playlist')}>
        <FieldGroup className="row">
          <FieldGroup className="col-sm-10">
            <FloatingLabelFormField
              caption={i18n.t("Content item")}
              name="content_id"
              required={true}
              runValidation={runValidation}
            >
              <SelectAsyncControl
                dataUrl={`/api/data/content.json`}
                disabledOptionsIds={existingContentIds}
                displayProperty="name"
                filters={{ type: 'content_service' }}
                labelKey="name"
                multi={false}
                onChange={this.onContentChange}
                pageSize={20}
                placeholder=""
                postGetOptions={this.augmentedOptionsDisplay}
                filterField="name"
                key={this.state.renderSelect}
                sortBy="name"
                valueKey="id"
              />
            </FloatingLabelFormField>
          </FieldGroup>

          <FieldGroup className="col-sm-2">
            <Button
              icon="plus"
              label={i18n.t('Add Content')}
              onClick={() => this.addPlaylistItem()}
              style="primary"
            />
          </FieldGroup>
        </FieldGroup>
      </FormSection>
    );
  }

  updateDatabase = (playlistItemId, newIndex) => {
    const url = `/admin/playlists/${this.state.id}/playlist_items/${playlistItemId}/update_position`;
    let idx = (newIndex + 1); // adjust for acts_as_list one-based indicies
    $.ajax({
      dataType: 'JSON',
      method: 'POST',
      url: url,
      data: {
        id: playlistItemId,
        new_index: idx
      },
      success: this.updateSuccess,
      error: this.updateError
    });
  }

  updateSuccess = () => {
    this.showAlert('success', i18n.t('Playlist order has been successfully saved.'));
  }

  updateError = () => {
    this.showAlert('danger', i18n.t('Unable to save Playlist order!'));
  }

  deleteConfirmation = (playlistItemId) => {
    let item = this.state.playlistItems.find((item) => { return item.id === playlistItemId })
    this.setState({
      isDeleting: true,
      toDeleteContentId: item.content.id,
      toDeleteId: playlistItemId,
      deleteMessage: i18n.t('Are you sure you wish to delete the "%s" Playlist Item?', {
        postProcess: 'sprintf',
        sprintf: [item.content.name]
      })
    });
  }

  deleteItem = () => {
    const { id, toDeleteId } = this.state;
    const url = `/admin/playlists/${id}/playlist_items/${toDeleteId}`;
    $.ajax({
      dataType: 'JSON',
      method: 'DELETE',
      url: url,
      data: {},
      error: this.deleteError,
      success: this.deleteSuccess
    });
  }

  deleteError = () => {
    this.showAlert('danger', i18n.t('Could not delete Playlist Item!'));
  }

  deleteSuccess = () => {
    const { toDeleteContentId } = this.state;
    const existingContentIds = this.state.existingContentIds.filter(id => parseInt(id) !== parseInt(toDeleteContentId));
    this.setState({ existingContentIds, renderSelect: toDeleteContentId });
    this.showAlert('success', i18n.t('Playlist Item deleted.'));
    this.removeItemFromState();
    this.clearDeletingEvent();
  }

  hideAlert = () => {
    this.setState({
      alertClass: '',
      alertMessage: '',
      hideAlert: true
    });
  }

  showAlert = (status, message) => {
    this.setState({
      alertClass: (`alert-${status}`),
      alertMessage: message,
      hideAlert: false
    });

    setTimeout(() => this.hideAlert(), 4000);
  }

  removeItemFromState = () => {
    let newList = $.grep(this.state.playlistItems, (item) => {
      return item.id !== this.state.toDeleteId;
    });

    this.setState({ playlistItems: newList });
  }

  clearDeletingEvent = () => {
    this.setState({
      isDeleting: false,
      itemToDelete: null,
      deleteMessage: ''
    });
  }

  closeModal = () => {
    this.clearDeletingEvent();
  }

  render() {
    let items = this.state.playlistItems.map((val, key) => (
      <PlaylistItem {...val.content}
        id={val.id}
        playlistId={this.props.id}
        key={key}
        sortData={val.id}
        onDeleteItem={() => { this.deleteConfirmation(val.id) }} />)
    );
    let alert;

    if (this.state.hideAlert) {
      alert = null
    } else {
      alert = <div id="update-message" className={`alert ${this.state.alertClass}`}>{this.state.alertMessage}</div>
    }

    return (
      <PageWrapper>
        <Section>
          {alert}
          {this.getContentSelect()}
          <ReactSortable
            onUpdate={(evt) => { this.updateDatabase(evt.item.id, evt.newIndex) }}
            list={this.state.playlistItems}
            setList={newState => this.setState({ playlistItems: newState })}
            className="content-sortable">
            {items}
          </ReactSortable>

          <Confirmation
            title="Confirm Deletion"
            message={this.state.deleteMessage}
            showModal={this.state.isDeleting}
            onConfirm={this.deleteItem}
            onClose={this.closeModal}
            confirmText={i18n.t("Delete")}
          />
        </Section>
      </PageWrapper>
    )
  }
}
